import { createRootRoute, createRouter } from "@tanstack/react-router";

import { AppShell } from "@/components/cinch/AppShell";
import { features } from "@/features/registry";

const rootRoute = createRootRoute({
  component: AppShell,
});

const featureRoutes = features.flatMap((f) => f.routes(rootRoute));
const routeTree = rootRoute.addChildren(featureRoutes);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
